/*
 * Copyright (c) 2026 Joseph Duggan. All rights reserved.
 */

/**
 * CSRF state for the Google Calendar OAuth connect flow.
 *
 * Before redirecting to Google's consent screen the SPA generates a
 * nonce and stashes it in sessionStorage; the callback page
 * (pages/GoogleOauthCallback.tsx) verifies the round-tripped `state`
 * against it before exchanging the code server-side.
 */

export const GOOGLE_OAUTH_STATE_KEY = 'google-oauth-state';

export function createGoogleOauthState(): string {
  const nonce = crypto.randomUUID();
  sessionStorage.setItem(GOOGLE_OAUTH_STATE_KEY, nonce);
  return nonce;
}
